import React from 'react'

import Utils from 'live/lib/utils'
import i18n from 'live/services/i18n'

import { AggregationState } from '../types'

export default function State({ aggregation }: { aggregation: AggregationState }) {
    const progress =
        aggregation?.progress?.current && aggregation?.progress?.total
            ? (aggregation.progress.current / aggregation.progress.total) * 100
            : null

    switch (aggregation.state) {
        case 'REBUILDING':
            return (
                <>
                    <i className={'fa fa-database'} style={{ color: '#37a3ef', marginRight: 4 }} />
                    {i18n('Rebuilding')} {progress && `(${Utils.formatNumber(progress, 0, 2)}%)`}
                </>
            )
        case 'REALTIME':
            return (
                <>
                    <i className={'fa fa-wave-sine'} style={{ color: '#01c292', marginRight: 4 }} />
                    {i18n('Running')}
                </>
            )
        case 'STOPPED':
            return (
                <>
                    <i className={'fa fa-ban'} style={{ color: '#d9534f', marginRight: 4 }} />
                    {i18n('Stopped')}
                </>
            )
        case 'WAIT_STOP':
                    return (
                        <>
                            <i className={'fa fa-ban'} style={{ color: '#d9534f', marginRight: 4 }} />
                            {i18n('Stopping Query...')}
                        </>
                    )
        case 'ERROR':
            return (
                <>
                    <i className={'fa fa-times'} style={{ color: '#d9534f', marginRight: 4 }} />
                    {i18n('Error')}
                </>
            )
        case 'WAITING':
            return (
                <>
                    <i className={'fa fa-hourglass-half'} style={{ color: '#606a80', marginRight: 4 }} />
                    {i18n('Waiting on queue')}
                </>
            )
        case 'LOADING':
            return (
                <>
                    <i className={'fa fa-hourglass-half'} style={{ color: '#606a80', marginRight: 4 }} />
                    {i18n('Loading')}
                </>
            )
        case 'TRANSITION':
            return (
                <>
                    <i className={'fa fa-hourglass-half'} style={{ color: '#606a80', marginRight: 4 }} />
                    {i18n('Loading')}
                </>
            )
        default:
            return aggregation.state
    }
}
